import { render, staticRenderFns } from "./VCollapseItem.vue?vue&type=template&id=690e4b92&scoped=true&"
import script from "./VCollapseItem.vue?vue&type=script&lang=js&"
export * from "./VCollapseItem.vue?vue&type=script&lang=js&"
import style0 from "./VCollapseItem.vue?vue&type=style&index=0&id=690e4b92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690e4b92",
  null
  
)

export default component.exports